var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoomsIconcomponent = function SvgRoomsIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.25h6a3 3 0 0 1 3 3V15h-1.5v-2.25H2.25V15H.75V3.75h1.5v6.75h6V5.25ZM7.5 7.5a2.247 2.247 0 0 1-2.25 2.25A2.247 2.247 0 0 1 3 7.5a2.247 2.247 0 0 1 2.25-2.25A2.247 2.247 0 0 1 7.5 7.5Z",
    fill: "#CECCC9"
  })));
};
export default SvgRoomsIconcomponent;